"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToReconnect() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="238504" id="ready-for-delivery" className="dark relative overflow-hidden bg-gradient-to-br from-background to-primary/20 py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.05]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/got_meds_com_medical_seal_watermark.png" alt="" className="h-auto w-[800px] max-w-none animate-pulse object-contain" aria-hidden="true" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto max-w-2xl px-6 text-center lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
          Ready to Simplify Your Health?
        </h2>
        
        <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-muted-foreground">
          Experience the premiere prescription delivery service in Atlanta. We coordinate directly with your doctors to ensure your medicine arrives swiftly and securely.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-x-6">
          <Button size="lg" className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-lg shadow-secondary/20 sm:w-auto font-default" asChild>
            <Link to="#">Get Started Now</Link>
          </Button>
          
          <Button variant="ghost" size="lg" className="w-full text-foreground hover:bg-primary/10 hover:text-primary sm:w-auto font-default" asChild>
            <Link to="/CareCyclePage">How It Works</Link>
          </Button>
        </div>
      </div>
    </section>;
}